import {ChevronIcon} from "assets/icons";
import {FC, PropsWithChildren, ReactNode, useState} from "react";

interface Props {
  header: ReactNode;
  initialExpanded?: boolean;
}

const Section: FC<PropsWithChildren<Props>> = ({header, children, initialExpanded = false}) => {
  const [expanded, setExpanded] = useState(initialExpanded);
  const [height, setHeight] = useState(0);
  const expandable = !!children;

  return (
    <div className="flex flex-col bg-brand-cream rounded-xl overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex gap-3 items-center justify-between px-4 py-3 text-sm font-semibold text-brand-navy"
      >
        {header}
        {expandable && (
          <ChevronIcon
            className="transform transition-transform shrink-0 text-brand-muted"
            style={{transform: !expanded ? "rotate(180deg)" : "rotate(0deg)"}}
          />
        )}
      </button>
      {expandable && (
        <div
          ref={(e) => setHeight(e?.scrollHeight || 0)}
          className="overflow-hidden w-full transition-all"
          style={{height: expanded && expandable ? height : 0, opacity: expanded && expandable ? 1 : 0}}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default Section;
